@if (bundle) {
  <div class="group-session">
    <app-assistance-editor
      [assistance]="bundle.main"
      [recurrenceEditingMode]="recurrenceEditingMode"
      [isInBundle]="true"
      [editableHandler]="editableHandler"
      (bundleChildAssistanceDeleted)="bundleChildAssistanceDeleted.emit($event)"
      (recurrenceEditingModeChange)="recurrenceEditingModeChange.emit($event)"
      (notifyURIDChange)="notifyURIDChange.emit($event)"
    >
      <!-- Projected via the editor's ng-content slot. -->
      <app-group-session-clients
        [bundle]="bundle"
        [editableHandler]="editableHandler"
        (reloadBundle)="reloadBundle.emit($event)"
      ></app-group-session-clients>
    </app-assistance-editor>
  </div>
}
